import types from '@/store/types/DesistimientoRenuncia'
import Vue from 'vue';

const state = {

  //datos para Desistimiento o Renuncia
  datosDesistimientoPe: {},
  //lugarDesarrollo:{},
  promociones:[],

  //datos para ampliacion
  //objEnviadasNetTodos:{},
  objDesistimientosNet: [],
  objDesistimientosAmplNet: []
}
const getters = {
  [types.getters.GetDatosDesistimientoPe]:(state) => {
      let objPe = state.datosDesistimientoPe;
      return objPe;
  },
//   [types.getters.GetlugarDesarrollo]:(state) => {
//       return state.lugarDesarrollo;
//   },
//   [types.getters.Getpromociones]:(state) => {
//       return state.promociones;
//   },
//   [types.getters.GetPromocionesEnviadasNetTodos]:(state) => {
//       return state.objEnviadasNetTodos;
//   },

  /* Relacionados a .NET */
  [types.getters.GetDesistimientosNet]:(state) => {
      return state.objDesistimientosNet;
  },

  [types.getters.GetDesistimientosAmplNet]:(state) => {
    return state.objDesistimientosAmplNet;
},
}
const mutations = {
  [types.mutations.SetDatosDesistimientoPe]:(state, obj) => {
    state.datosDesistimientoPe = obj;
  },
//   [types.mutations.SetlugarDesarrollo]:(state, obj) => {
//       state.lugarDesarrollo = obj;
//   },
//   [types.mutations.SetDesistimiento]:(state, obj) => {
//       state.desistimiento = obj;
//   },
//   [types.mutations.SetPromocionesEnviadasNetTodos]:(state, objEnviadasNetTodos) => {
//       state.objEnviadasNetTodos = objEnviadasNetTodos;
//   },

  /* Relacionados a .NET */
  [types.mutations.SetDesistimientosRenunciasNet]:(state, objDesistimientosNet) => {
      state.objDesistimientosNet = objDesistimientosNet;
  },
  [types.mutations.SetDesistimientosRenunciasAmplNet]:(state, objDesistimientosAmplNet) => {
    state.objDesistimientosAmplNet = objDesistimientosAmplNet;
  },
}
const actions = {
  [types.actions.RegistrarDesistimiento]:({commit}, pObj) => {
      return new Promise ((resolve,reject)=>{
          Vue.prototype.$http.post(`pajel/desistimiento_renuncia/add`,pObj)
            .then(r => {
               let obj = r.data.resultado;
              commit(types.mutations.SetDatosDesistimientoPe, obj);
              resolve(r);
          })
      })
  },
  [types.actions.ModificarDesistimiento]:({commit}, pObj) => {
      return new Promise ((resolve,reject)=>{
          Vue.prototype.$http.put(`pajel/desistimiento_renuncia/update/${pObj.desistimientoRenunciaId}`, pObj).then(r=>{
              let obj = r.data.resultado;
              commit(types.mutations.SetDatosDesistimientoPe, obj);
              resolve(r);
          })
      })
  },
  [types.actions.EliminarSolicitudDesistimiento]:({commit}, pSolicitudId) => {
    return new Promise ((resolve,reject) => {
      Vue.prototype.$http.delete(`pajel/desistimiento_renuncia/delete_desistimiento/${pSolicitudId}`)
        .then(r => {
          resolve(r);
        });
    });
  },
  [types.actions.ObtenerDesistimiento]:({commit}, pObj)=> {
    commit(types.mutations.SetDatosDesistimientoPe, {});
    return new Promise ((resolve,reject)=>{
        Vue.prototype.$http.get(`pajel/desistimiento_renuncia/find/${pObj.solicitudId}/${pObj.promocionEmpresarialNetId}/${pObj.ampliacionNetId}/${pObj.tipoDesistimientoRenunciaId}/${pObj.estadoDesistimientoRenunciaId}`)
            .then(r => {
                if (Object.keys(r.data).length > 0) {
                  commit(types.mutations.SetDatosDesistimientoPe, r.data);
                }
                else {
                  if (pObj.ampliacionNetId > 0) {
                    //pObj.tipoDesistimientoRenunciaId = pObj.cadenaCiteResolucionAmp == null || pObj.cadenaCiteResolucionAmp == '' ? 2161 : 2162;
                    pObj.tipoDesistimientoRenunciaId = pObj.fechaNotificacionResAmp == null || pObj.fechaNotificacionResAmp == '' ? 2161 : 2162;
                  }
                  else {
                    //pObj.tipoDesistimientoRenunciaId = pObj.cadenaCiteResolucion == null || pObj.cadenaCiteResolucion == '' ? 2161 : 2162;
                    pObj.tipoDesistimientoRenunciaId = pObj.fechaNotificacionRes == null || pObj.fechaNotificacionRes == '' ? 2161 : 2162;
                  }
                  commit(types.mutations.SetDatosDesistimientoPe, pObj);
                }
              resolve(r);
            });
      })
  },

  [types.actions.ObtenerDocumentoBorrador]:({commit}, pObj)=> {
    commit(types.mutations.SetDatosDesistimientoPe, {});
    return new Promise ((resolve,reject)=>{
        Vue.prototype.$http.get(`pajel/desistimiento_renuncia/find/by/promocionnetid/tipo/estado/${pObj.promocionEmpresarialNetId}/${pObj.tipoDesistimientoRenunciaId}/${pObj.estadoDesistimientoRenunciaId}`)
            .then(r => {
                if (Object.keys(r.data).length > 0) {
                  commit(types.mutations.SetDatosDesistimientoPe, r.data);
                }
                else {
                  if (pObj.ampliacionNetId > 0) {
                    //pObj.tipoDesistimientoRenunciaId = pObj.cadenaCiteResolucionAmp == null || pObj.cadenaCiteResolucionAmp == '' ? 2161 : 2162;
                    pObj.tipoDesistimientoRenunciaId = pObj.fechaNotificacionResAmp == null || pObj.fechaNotificacionResAmp == '' ? 2161 : 2162;
                  }
                  else {
                    //pObj.tipoDesistimientoRenunciaId = pObj.cadenaCiteResolucion == null || pObj.cadenaCiteResolucion == '' ? 2161 : 2162;
                    pObj.tipoDesistimientoRenunciaId = pObj.fechaNotificacionRes == null || pObj.fechaNotificacionRes == '' ? 2161 : 2162;
                  }
                  commit(types.mutations.SetDatosDesistimientoPe, pObj);
                }
              resolve(r);
            });
      })
  },

  /* Consumo de Servicios Relacionados a .NET */
  [types.actions.ObtenerDesistimientosRenunciasNet]:({commit}, pPersonaId) => {
    commit(types.mutations.SetDesistimientosRenunciasNet, []);
    return new Promise ((resolve, reject)=>{
        Vue.prototype.$http.get(`pajel/desistimiento_renuncia/net/list/${pPersonaId}`)
          .then(r => {
            commit(types.mutations.SetDesistimientosRenunciasNet, r.data)
            resolve(r);
        });
    });
  },
  [types.actions.ObtenerDesistimientosRenunciasAmplNet]:({commit}, pPersonaId) => {
    commit(types.mutations.SetDesistimientosRenunciasAmplNet, []);
    return new Promise ((resolve, reject)=>{
        Vue.prototype.$http.get(`pajel/desistimiento_renuncia/net/ampliaciones/list/${pPersonaId}`)
          .then(r => {
            commit(types.mutations.SetDesistimientosRenunciasAmplNet, r.data)
            resolve(r);
        });
    });
  },
  [types.actions.EnviarSolicitudDesistimiento]:({commit}, pObj) => {
    return new Promise ((resolve,reject)=>{
      Vue.prototype.$http.post(`pajel/desistimiento_renuncia/net/enviar_solicitud`, pObj)
        .then(r => {
          resolve(r);
        });
    });
  },
}
export default {
  state,
  actions,
  getters,
  mutations
}
